import type { FC } from 'react';
import { XIcon } from '@heroicons/react/outline';
import clsx from 'clsx';

const ROWS = [
  { width: 'w-4/5', isWrapped: true },
  { width: 'w-3/5', isWrapped: false },
  { width: 'w-11/12', isWrapped: true },
  { width: 'w-2/3', isWrapped: false },
  { width: 'w-3/4', isWrapped: false },
];

const BAR = 'rounded bg-slate-200';

const SkeletonGroup: FC<{ idPrefix: string }> = ({ idPrefix }) => (
  <>
    <div className="border-info-200 bg-info-50 border-y py-1.5 pr-3 pl-7.5">
      <div className={clsx(BAR, 'h-3 w-24')} />
    </div>
    {ROWS.map((row, idx) => (
      <div className="flex items-start gap-3 px-7.5 py-3" key={`${idPrefix}-${idx}`}>
        <span className="flex h-[18px] shrink-0 items-center">
          <span className={clsx(BAR, 'h-2 w-2 rounded-full')} />
        </span>
        <div className="min-w-0 flex-1">
          <div className={clsx(BAR, 'h-4', row.width)} />
          {row.isWrapped && <div className={clsx(BAR, 'mt-1.5 h-4 w-2/5')} />}
          <div className={clsx(BAR, 'mt-2 h-3 w-28')} />
        </div>
      </div>
    ))}
  </>
);

export const ActivityLoading: FC<{ onClose?: () => void }> = ({ onClose }) => (
  <div className="flex w-full flex-col bg-white" role="status" aria-live="polite" aria-busy="true">
    <span className="sr-only">Loading…</span>
    <div className="border-info-200 flex items-center justify-between border-b px-7.5 py-[15px]">
      <h2 className="text-base leading-6 font-normal text-black">Activity</h2>
      {onClose && <XIcon className="text-info-900 hover:text-info-600 size-4.5 cursor-pointer" onClick={onClose} />}
    </div>
    <div className="animate-pulse" aria-hidden>
      <div className="flex items-center gap-4 px-7.5 py-4">
        <div className={clsx(BAR, 'h-[30px] flex-1 rounded-md')} />
        <div className={clsx(BAR, 'h-[30px] w-[30px] rounded-md')} />
      </div>
      <div className="overflow-hidden">
        <SkeletonGroup idPrefix="today" />
        <SkeletonGroup idPrefix="earlier" />
      </div>
    </div>
  </div>
);
